import React, { useEffect } from 'react';
import {
  useTable,
  useSortBy,
  useFlexLayout,
  useResizeColumns,
  usePagination,
} from "react-table";
import { Button } from 'react-bootstrap';
import { DateTime } from "luxon";


function Table({ columns, data, intl }) {
  // Use the state and functions returned from useTable to build your UI
  const defaultColumn = React.useMemo(
    () => ({
      // When using the useFlexLayout:
      minWidth: 30, // minWidth is only used as a limit for resizing
      width: 150, // width is used for both the flex-basis and flex-grow
      maxWidth: 200 // maxWidth is only used as a limit for resizing
    }),
    []
  );
  const {
    getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      pageOptions,
      page,
      state: { pageIndex },
      previousPage,
      nextPage,
      setPageSize,
      canPreviousPage,
      canNextPage,
    } = useTable(
      {
        columns,
        data,
        defaultColumn,
        // initialState: { pageIndex: 1 }
        initialState: {
          sortBy: [
            {
              id: "timestamp",
              desc: true,
            },
          ],
        },
      },
      useSortBy,
      useFlexLayout,
      useResizeColumns,
      usePagination
  );


  useEffect(() => {
    setPageSize(6);
  }, [setPageSize]);

  // Render the UI for your table\
  return (
    <React.Fragment>
      <div className="table-responsive">
          <div className="ReactTable react-table-custom" {...getTableProps()}>
            <div className="rt-thead -header">
              {headerGroups.map((headerGroup) => (
                <div className="rt-tr" {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <div
                      className="rt-th"
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                      <span
                        {...column.getResizerProps()}
                        className={`resizer ${
                          column.isResizing ? "isResizing" : ""
                        }`}
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="rt-tbody" {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <div className="rt-tr-group" {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <div className="rt-td" {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      <div className="text-center pagination justify-content-center">
        <Button
          variant="link"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <img alt="" src="/icons/arrow-left-white.png" />
        </Button>
        <span style={{ marginTop: "8px" }}>
          {pageIndex + 1} / {pageOptions.length}
        </span>
        <Button
          variant="link"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          <img alt="" src="/icons/arrow-right-white.png" />
        </Button>
      </div>
    </React.Fragment>
  );
}

const ProfileTable = ({intl, transactions}) => {
  useEffect(() => {
    document.getElementById('credits-coulmn').parentElement.classList.add('credits-coulmn')
  }, []);

  const columns =[
    {
      accessor: "timestamp",
      Header: intl.formatMessage({
        id: "table.transactions.date",
      }),
      // filterable: false,
      Cell: (props) => (
        <div>
          {DateTime.fromISO(props.row.original.timestamp)
            .setLocale(intl.locale)
            .toLocaleString(DateTime.DATETIME_MED)}
        </div>
      ),
    },
    {
      accessor: "type",
      Header: intl.formatMessage({
        id: "table.transactions.type",
      }),
      Cell: (props) => <div>{props.row.original.type}</div>,
    },
    {
      accessor: "credits",
      Header: () => (<div id="credits-coulmn">
      {
        intl.formatMessage({
          id: "table.transactions.credits",
        })
      }
    </div>),
      Cell: (props) => (
        <div className="credits-coulmn">
          {props.row.original.credits}
        </div>
      ),
    },
    {
      accessor: "charge_info.amount",
      Header: intl.formatMessage({
        id: "table.transactions.amount",
      }),
      filterable: false,
      Cell: (props) => (
        <div>
          {props.row.original.charge_info &&
          props.row.original.charge_info.amount
            ? `€ ${
                parseInt(props.row.original.charge_info.amount) / 100
              }`
            : ""}
        </div>
      ),
    },
    {
      accessor: "charge_info.invoice",
      filterable: false,
      sortable: false,
      Header: intl.formatMessage({
        id: "table.transactions.invoice",
      }),
      Cell: (props) => {
        if (
          props.row.original.type === "credit" &&
          props.row.original.charge_info
        ) {
          return (
            <div>
              <a
                href={`http://invoices.e-slides.net.s3-website.ap-south-1.amazonaws.com/${props.row.original._id}.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Invoice
              </a>
            </div>
          );
        }
        return <div />;
      },
    },
  ];
  return (
    <React.Fragment>
      <Table columns={columns} data={transactions} intl={intl} />
    </React.Fragment>
  )
}

export default ProfileTable;